var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.63636H21M8.95455 16.2273V9.40909M13.0455 16.2273V9.40909M13.0455 1H8.95455C8.59289 1 8.24604 1.14367 7.99031 1.3994C7.73458 1.65513 7.59091 2.00198 7.59091 2.36364V4.63636H14.4091V2.36364C14.4091 2.00198 14.2654 1.65513 14.0097 1.3994C13.754 1.14367 13.4071 1 13.0455 1ZM17.2364 19.7455C17.2111 20.0871 17.0573 20.4065 16.8059 20.6392C16.5546 20.872 16.2244 21.0009 15.8818 21H6.11818C5.77561 21.0009 5.4454 20.872 5.19406 20.6392C4.94273 20.4065 4.78893 20.0871 4.76364 19.7455L3.5 4.63636H18.5L17.2364 19.7455Z",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a7462dba3766e9f12ed0e1ca9a45edfc.svg";
export { ForwardRef as ReactComponent };